module.exports = __webpack_public_path__ + "img/layout3.ab33999e.png";